"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = __toESM(require("react"), 1);
var import_react_test_renderer = __toESM(require("react-test-renderer"), 1);
var import_vitest = require("vitest");
var import_hooks = require("../hooks");
var import_Root = require("../Root");
var import_Navigator = require("../views/Navigator");
var _globalThis;
var _requestAnimationFrame;
var _globalThis1;
var _cancelAnimationFrame;
globalThis.IS_REACT_ACT_ENVIRONMENT = true;
(_requestAnimationFrame = (_globalThis = globalThis).requestAnimationFrame) !== null && _requestAnimationFrame !== void 0 ? _requestAnimationFrame : _globalThis.requestAnimationFrame = function(cb) {
  return setTimeout(function() {
    return cb(0);
  }, 0);
};
(_cancelAnimationFrame = (_globalThis1 = globalThis).cancelAnimationFrame) !== null && _cancelAnimationFrame !== void 0 ? _cancelAnimationFrame : _globalThis1.cancelAnimationFrame = function(id) {
  return clearTimeout(id);
};
var routerRoot = "app";
function makeRoutes(modules) {
  var _globalThis___vxrnVersion;
  globalThis["__vxrnVersion"] = ((_globalThis___vxrnVersion = globalThis["__vxrnVersion"]) !== null && _globalThis___vxrnVersion !== void 0 ? _globalThis___vxrnVersion : 0) + 1;
  var routes = {};
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = Object.entries(modules)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var [file, module2] = _step.value;
      routes[`/${routerRoot}/${file}`] = module2;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return routes;
}
var slotLayout = {
  default: function() {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Navigator.Slot, {});
  }
};
var leaf = function(label) {
  return {
    default: function() {
      return label;
    }
  };
};
function routeTreeWithGate(gate) {
  var Gate = gate;
  return makeRoutes({
    "_layout.tsx": slotLayout,
    "(app)/_layout.tsx": {
      default: function() {
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Gate, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Navigator.Slot, {})
        });
      }
    },
    "(app)/index.tsx": leaf("app-index"),
    "(app)/project/_layout.tsx": slotLayout,
    "(app)/project/[projectId]/_layout.tsx": slotLayout,
    "(app)/project/[projectId]/[sessionId]/_layout.tsx": slotLayout,
    "(app)/project/[projectId]/[sessionId]/index.tsx": leaf("session"),
    "(site)/_layout.tsx": slotLayout,
    "(site)/pricing.tsx": leaf("pricing")
  });
}
function renderAt(path, routes) {
  var renderer;
  (0, import_react_test_renderer.act)(function() {
    renderer = import_react_test_renderer.default.create(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Root.Root, {
      path,
      routes,
      routerRoot,
      isClient: false
    }));
  });
  return renderer;
}
function bodyText(renderer) {
  var collect = function(node) {
    var _node_children;
    return typeof node === "string" ? node : Array.isArray(node) ? node.map(collect).join("") : node ? collect((_node_children = node.children) !== null && _node_children !== void 0 ? _node_children : []) : "";
  };
  return collect(renderer.toJSON());
}
(0, import_vitest.describe)("a layout that renders something other than its <Slot />", function() {
  (0, import_vitest.it)("does not move the pathname while the URL stands still", function() {
    var pathnames = [];
    var setBlocked;
    function Probe() {
      var pathname = (0, import_hooks.usePathname)();
      if (pathnames[pathnames.length - 1] !== pathname) pathnames.push(pathname);
      return null;
    }
    function Gate(param) {
      var { children } = param;
      var [blocked, set] = import_react.default.useState(true);
      setBlocked = set;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Probe, {}),
          blocked ? "placeholder" : children
        ]
      });
    }
    var renderer = renderAt("/project/p1/main", routeTreeWithGate(Gate));
    (0, import_vitest.expect)(bodyText(renderer)).toBe("placeholder");
    (0, import_react_test_renderer.act)(function() {
      return setBlocked(false);
    });
    (0, import_vitest.expect)(bodyText(renderer)).toBe("session");
    (0, import_react_test_renderer.act)(function() {
      return setBlocked(true);
    });
    (0, import_vitest.expect)(bodyText(renderer)).toBe("placeholder");
    (0, import_react_test_renderer.act)(function() {
      return setBlocked(false);
    });
    (0, import_vitest.expect)(pathnames).toEqual([
      "/project/p1/main"
    ]);
  });
  (0, import_vitest.it)("settles when the gate itself reads the pathname", async function() {
    var renders = 0;
    var requestBlock;
    function Gate(param) {
      var { children } = param;
      var pathname = (0, import_hooks.usePathname)();
      var [blockRequested, setBlockRequested] = import_react.default.useState(false);
      requestBlock = function() {
        return setBlockRequested(true);
      };
      renders++;
      if (renders > 100) {
        throw new Error(`gate rendered ${renders} times without settling`);
      }
      var blocked = blockRequested && pathname.startsWith("/project/");
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
        children: blocked ? "blocked" : children
      });
    }
    var renderer = renderAt("/project/p1/main", routeTreeWithGate(Gate));
    await (0, import_react_test_renderer.act)(async function() {
    });
    (0, import_vitest.expect)(bodyText(renderer)).toBe("session");
    await (0, import_react_test_renderer.act)(async function() {
      return requestBlock();
    });
    await (0, import_react_test_renderer.act)(async function() {
    });
    (0, import_vitest.expect)(bodyText(renderer)).toBe("blocked");
    (0, import_vitest.expect)(renders).toBeLessThan(20);
  });
});
//# sourceMappingURL=conditionalSlotPathname.test.js.map
